const initialState = {
    loggedIn: false,
    checkingAuth: true,
    isAdmin: false,
};

export default function auth(state = initialState, action) {
    switch (action.type) {
        case 'CHECK_AUTH':
            return {
                ...state,
                checkingAuth: true,
            };
        case 'CHECKED_AUTH':
            return {
                ...state,
                checkingAuth: false,
            };
        case 'USER_LOGGED_IN':
            return {
                ...state,
                checkingAuth: false,
                loggedIn: true,
                isAdmin: action.admin,
            };
        case 'LOGIN':
            return {
                ...state,
                loggedIn: true,
            };
        case 'LOGOUT':
            return {
                ...state,
                loggedIn: false,
                isAdmin: false,
            };
        default:
            return state;
    }
}
